module.exports = __webpack_public_path__ + "static/media/Univers-light.f0ddac1b.woff";